module.exports = __webpack_public_path__ + "media/images/mock-thumbs/article-1-083764cb8b112a685ece794bdbe544b2.png";